module.exports = __webpack_public_path__ + "static/img_4867-218f14b686c91e16b5bde7d176272f73.webp";